<div *ngIf="isShow" [ngClass.gt-sm]="'desktop'" class="content" fxLayoutAlign="center center" fxLayout="row">
    <img src="{{licenceService.getKey('icon-loader-img')}}" alt="loader-logo" />
</div>